import { useState } from 'react';
import { Plus } from 'lucide-react';
import { CouponFilters } from './components/CouponFilters';
import { CouponTable } from './components/CouponTable';
import { CouponForm } from './components/CouponForm';

export default function CouponsPage() {
  const [creating, setCreating] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-3xl font-bold">Coupons</h2>
          <p className="text-sm text-on-surface-variant mt-1">
            Create discount codes, control when they are live, and track who redeemed them.
          </p>
        </div>
        <button
          onClick={() => setCreating(true)}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-electric-violet text-white text-xs font-bold uppercase tracking-widest hover:bg-electric-violet/90"
        >
          <Plus className="w-4 h-4" /> Create coupon
        </button>
      </div>
      <CouponFilters />
      <CouponTable />
      <CouponForm open={creating} mode="create" onClose={() => setCreating(false)} />
    </div>
  );
}
